import { useTranslation } from 'react-i18next';

const articles = [
  {
    key: 'spreadsheet',
    title: 'CSSBuy Spreadsheet: Guia Completo',
    desc: 'Um guia abrangente para entender e usar o CSSBuy Spreadsheet de forma eficiente.',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20shopping%20spreadsheet%20interface%20with%20a%20product%20grid%20on%20a%20screen%20dark%20mode%20UI%20warm%20lighting%20editorial%20photography%20minimal%20setup&width=600&height=400&seq=article-spreadsheet-02&orientation=landscape&nocache=true',
    href: '/cssbuy-spreadsheet/',
  },
  {
    key: 'review',
    title: 'CSSBuy Review: Análise Completa',
    desc: 'Review detalhada do CSSBuy: funcionalidades, limitações e pontos importantes.',
    image: 'https://readdy.ai/api/search-image?query=An%20opened%20premium%20parcel%20box%20revealing%20streetwear%20products%20on%20a%20clean%20surface%20warm%20natural%20lighting%20editorial%20photography%20minimal%20background&width=600&height=400&seq=article-review-02&orientation=landscape&nocache=true',
    href: '/cssbuy-review/',
  },
  {
    key: 'shipping',
    title: 'CSSBuy Shipping Cost: Guia de Envio',
    desc: 'Entenda os fatores que influenciam o custo de envio internacional.',
    image: 'https://readdy.ai/api/search-image?query=International%20shipping%20parcels%20moving%20along%20a%20conveyor%20belt%20in%20a%20modern%20logistics%20facility%20warm%20lighting%20editorial%20photography%20clean%20environment&width=600&height=400&seq=article-shipping-02&orientation=landscape&nocache=true',
    href: '/shipping/',
  },
  {
    key: 'coupon',
    title: 'CSSBuy Coupon: Como Verificar Ofertas',
    desc: 'Saiba como encontrar e verificar cupons CSSBuy antes de utilizá-los.',
    image: 'https://readdy.ai/api/search-image?query=A%20shopping%20coupon%20and%20discount%20tags%20arranged%20on%20a%20clean%20desk%20beside%20a%20laptop%20showing%20an%20online%20store%20warm%20natural%20lighting%20editorial%20photography%20minimal%20composition&width=600&height=400&seq=article-coupon-01&orientation=landscape',
    href: '/article/cssbuy-coupon/',
  },
  {
    key: 'discount',
    title: 'CSSBuy Discount Code: O Que Checar',
    desc: 'Entenda como verificar códigos de desconto e evitar armadilhas comuns.',
    image: 'https://readdy.ai/api/search-image?query=A%20percentage%20discount%20badge%20and%20price%20tags%20on%20a%20clean%20background%20warm%20natural%20lighting%20editorial%20photography%20minimal%20composition&width=600&height=400&seq=article-discount-01&orientation=landscape',
    href: '/article/cssbuy-discount-code/',
  },
  {
    key: 'warehouse',
    title: 'CSSBuy Warehouse: Armazenamento e QC',
    desc: 'Entenda como funciona o armazenamento e a preparação de pedidos.',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20warehouse%20interior%20with%20organized%20shelves%20and%20stacked%20parcels%20warm%20industrial%20lighting%20editorial%20photography%20clean%20professional%20environment&width=600&height=400&seq=article-warehouse-01&orientation=landscape',
    href: '/article/cssbuy-warehouse/',
  },
  {
    key: 'legit',
    title: 'CSSBuy Legit: Guia de Confiança',
    desc: 'Análise independente sobre legitimidade e como se proteger ao comprar.',
    image: 'https://readdy.ai/api/search-image?query=A%20trust%20and%20security%20concept%20with%20a%20shield%20and%20verified%20badge%20on%20a%20clean%20background%20warm%20natural%20lighting%20editorial%20photography%20minimal%20composition&width=600&height=400&seq=article-legit-01&orientation=landscape',
    href: '/article/cssbuy-legit/',
  },
  {
    key: 'qc',
    title: 'CSSBuy QC: Controle de Qualidade',
    desc: 'Aprenda como solicitar e interpretar as fotos de QC.',
    image: 'https://readdy.ai/api/search-image?query=A%20quality%20control%20inspection%20of%20a%20product%20with%20a%20magnifying%20glass%20and%20checklist%20on%20a%20clean%20desk%20warm%20natural%20lighting%20editorial%20photography&width=600&height=400&seq=article-qc-01&orientation=landscape',
    href: '/article/cssbuy-qc/',
  },
  {
    key: 'vs-superbuy',
    title: 'CSSBuy vs Superbuy: Comparação',
    desc: 'Comparação objetiva entre CSSBuy e Superbuy para escolher melhor.',
    image: 'https://readdy.ai/api/search-image?query=Two%20contrasting%20shopping%20carts%20side%20by%20side%20as%20a%20comparison%20concept%20on%20a%20clean%20background%20warm%20natural%20lighting%20editorial%20photography%20minimal%20composition&width=600&height=400&seq=article-vs-superbuy-01&orientation=landscape',
    href: '/article/cssbuy-vs-superbuy/',
  },
  {
    key: 'buying',
    title: 'CSSBuy Buying Guide: Comprar com Confiança',
    desc: 'Guia completo de compra: pesquisa, verificação e decisão segura.',
    image: 'https://readdy.ai/api/search-image?query=Hands%20holding%20a%20smartphone%20browsing%20an%20online%20shopping%20app%20with%20a%20product%20grid%20warm%20natural%20lighting%20editorial%20photography%20minimal%20composition&width=600&height=400&seq=article-buying-01&orientation=landscape',
    href: '/article/cssbuy-buying-guide/',
  },
  {
    key: 'shipping-guide',
    title: 'CSSBuy Shipping Guide: Métodos e Custos',
    desc: 'Guia sobre métodos de envio, prazos e dicas para reduzir despesas.',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20with%20shipping%20labels%20warm%20natural%20lighting%20editorial%20photography%20clean%20professional%20environment&width=600&height=400&seq=article-shipping-guide-01&orientation=landscape',
    href: '/article/cssbuy-shipping-guide/',
  },
  {
    key: 'alternatives',
    title: 'CSSBuy Alternatives: Outras Opções',
    desc: 'Explore alternativas como Superbuy e Sugargoo com comparação objetiva.',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20online%20shopping%20options%20displayed%20as%20cards%20in%20a%20comparison%20concept%20warm%20natural%20lighting%20editorial%20photography%20minimal%20composition&width=600&height=400&seq=article-alternatives-01&orientation=landscape',
    href: '/article/cssbuy-alternatives/',
  },
  {
    key: 'beginner',
    title: 'CSSBuy Beginner Guide: Primeiros Passos',
    desc: 'Guia para iniciantes: como funciona e erros comuns a evitar.',
    image: 'https://readdy.ai/api/search-image?query=A%20first%20time%20online%20shopper%20starting%20a%20journey%20with%20a%20smartphone%20and%20a%20package%20warm%20natural%20lighting%20editorial%20photography%20minimal%20composition&width=600&height=400&seq=article-beginner-01&orientation=landscape',
    href: '/article/cssbuy-beginner-guide/',
  },
];

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-2">
                Artigos e Guias
              </h2>
              <p className="text-foreground-600 text-sm">
                Conteúdo original para ajudar você a usar o CSSBuy Spreadsheet com mais confiança.
              </p>
            </div>
            <a
              href="/guides/"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              {t('learn_more')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article) => (
              <a
                key={article.key}
                href={article.href}
                className="group block bg-white rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 hover:shadow-md transition-all"
              >
                <div className="aspect-[3/2] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-semibold text-sm text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 mb-4">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                    {t('read_more')}
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center" />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}